import type { EffectDefinition, EffectContext } from './types'

interface MatrixColumn {
  x: number
  chars: string[]
  y: number
  speed: number
  charSize: number
  opacity: number
}

const CHARS = Array.from('アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン0123456789ABCDEF')

function randomChar(): string {
  return CHARS[Math.floor(Math.random() * CHARS.length)]!
}

function createColumn(x: number, height: number, charSize: number): MatrixColumn {
  const length = 8 + Math.floor(Math.random() * 16)
  const chars: string[] = []
  for (let i = 0; i < length; i++) {
    chars.push(randomChar())
  }
  return {
    x,
    chars,
    y: Math.random() * height * -1,
    speed: 60 + Math.random() * 100,
    charSize,
    opacity: 0.4 + Math.random() * 0.4
  }
}

export const matrix: EffectDefinition = {
  id: 'matrix',
  name: 'Matrix Rain',

  init(ctx: EffectContext) {
    const charSize = 14
    const gap = charSize + 4
    const cols: MatrixColumn[] = []
    for (let x = 0; x < ctx.width; x += gap) {
      if (Math.random() > 0.5) {
        cols.push(createColumn(x, ctx.height, charSize))
      }
    }
    return cols
  },

  update(state: unknown, ctx: EffectContext) {
    const cols = state as MatrixColumn[]
    const dt = ctx.deltaTime / 1000
    for (const col of cols) {
      col.y += col.speed * dt
      // Randomly change characters
      if (Math.random() < 0.02) {
        const idx = Math.floor(Math.random() * col.chars.length)
        col.chars[idx] = randomChar()
      }
      if (col.y > ctx.height + col.chars.length * col.charSize) {
        col.y = -(col.chars.length * col.charSize)
        col.speed = 60 + Math.random() * 100
      }
    }
  },

  draw(state: unknown, ctx: EffectContext) {
    const cols = state as MatrixColumn[]
    const { ctx: c } = ctx
    c.font = '14px monospace'
    c.textAlign = 'center'

    for (const col of cols) {
      for (let i = 0; i < col.chars.length; i++) {
        const charY = col.y + i * col.charSize
        if (charY < -col.charSize || charY > ctx.height + col.charSize) continue

        const isHead = i === col.chars.length - 1
        const fade = 1 - (i / col.chars.length)

        if (isHead) {
          c.fillStyle = `rgba(180, 255, 180, ${col.opacity * 0.9})`
        } else {
          c.fillStyle = `rgba(0, 200, 70, ${col.opacity * fade * 0.5})`
        }
        c.fillText(col.chars[i]!, col.x, charY)
      }
    }
  }
}
